var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._l((_vm.errors), function(error, index) {
    return _c('b-alert', {
      attrs: {
        "variant": "danger",
        "dismissible": "",
        "show": _vm.showError
      },
      on: {
        "dismissed": function($event) {
          _vm.dismissErrors(index)
        }
      }
    }, [_c('div', [_c('strong', [_vm._v("ERROR:")]), _vm._v(" " + _vm._s(error.message) + " ")])])
  }), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='icon-folder'></i> Files"
    }
  }, [_c('paginate', {
    staticClass: "paginate-list",
    attrs: {
      "name": "files",
      "list": _vm.files,
      "tag": "div",
      "per": 20
    }
  }, [(_vm.files !== null && _vm.files.length !== 0) ? _c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("File")]), _vm._v(" "), _c('th', [_vm._v("Size")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginated('files')), function(file) {
    return _c('tr', [_c('td', [_c('button', {
      staticClass: "btn btn-primary btn-micro",
      on: {
        "click": function($event) {
          _vm.downloadFile(file)
        }
      }
    }, [_vm._v("Download")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(file.uploadTime, "MM/DD/YYYY HH:mm:ss")))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.downloadFile(file)
        }
      }
    }, [_vm._v(_vm._s(file.description))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size, 2)))])])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.files !== null && _vm.files.length !== 0) ? _c('paginate-links', {
    attrs: {
      "for": "files",
      "limit": 2,
      "show-step-links": true,
      "classes": {
        'ul': ['pagination', 'justify-content-center']
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.files !== null && _vm.files.length === 0) ? _c('div', [_vm._v("No Files Found")]) : _vm._e(), _vm._v(" "), (_vm.files === null && _vm.errors.length === 0) ? _c('div', [_vm._v("\n      Loading File List "), _c('img', {
    attrs: {
      "src": require('../assets/spinner.svg'),
      "width": "25em",
      "height": "25em"
    }
  })]) : _vm._e()], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91d5b070","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GetFiles.vue
// module id = ZKzH
// module chunks = 1